import React from 'react';
import { Redirect } from 'react-router-dom';

const CompleteProfilePage = () => <Redirect to="/perfil" />;

export default CompleteProfilePage;
